module.exports = __webpack_public_path__ + "static/media/manchester_city.1d5b64ec.png";